module.exports = __webpack_public_path__ + "static/media/ycard_paypal.54b6c0b1.svg";